import React, { useState, useContext, useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';

import { ResponsiveContext, EtapesSaisieContext } from '../../App';
import { Simulation, NotesTrimestre, MessageSaisieTrim, MessagePointsAuDessus10, SimulationBaseNotes } from '../../types/main';
import { creeClassNamesZoneSaisie } from '../../utils/utils';
import { SaisieContext } from '../formConteneur';
import { MySelect } from '../champsSaisieAffichage/mySelect';
import { MyListeBoutons } from '../champsSaisieAffichage/myListeBoutons';
import { MyTextInput } from '../champsSaisieAffichage/myTextInput';
import { PointsNote } from '../autres/points';
import { MyCheckboxInput } from '../champsSaisieAffichage/myCheckboxInput';
import { Aide } from '../autres/aide';
// import { MyTextInput } from '../champsSaisieAffichage/myTextInput';
// import { VoirDetail } from '../boutons/generaux/voirDetail';
interface SaisieNoteCCProps {
  name: string;
  label: string;
  coef: number | string;
  noteUnique?: boolean;
  spe?: boolean;
  pointsAuDessus10?: boolean;
}
export const SaisieNoteCC: React.FC<SaisieNoteCCProps> = ({
  name,
  label,
  coef,
  noteUnique,
  spe,
  pointsAuDessus10,
}) => {
  const { etapesSaisie, indexEtapeDansRubrique, indexRubriqueSaisie } = useContext(EtapesSaisieContext);
  const { dimensions } = useContext(ResponsiveContext);
  const { modeAffichage, setBoutonSuivant } = useContext(SaisieContext);
  const { values, setFieldValue } = useFormikContext();
  const [classNamesZoneSaisie, setClassNamesZoneSaisie] = useState(creeClassNamesZoneSaisie(dimensions.largeur, 4));
  const ref = useRef<HTMLInputElement>(null);
  const simulation = values as Simulation ;
  const {
    specialite,
  } = simulation;

  useEffect(() => {
    setClassNamesZoneSaisie(creeClassNamesZoneSaisie(dimensions.largeur, 4));
  }, [dimensions]);

  useEffect(() => {
    if (1 === 1
      // francais_ecrit !== ''
      // && francais_oral !== ''
      // && sciences !== ''
      // && TPE !== ''
    ) {
      setBoutonSuivant('oui');
    } else {
      setBoutonSuivant('disabled');
    }
  }, [simulation, indexRubriqueSaisie, indexEtapeDansRubrique])


  useEffect(() => {
    if (!noteUnique) {
      const tabNotesTrim = simulation[`${name}_t` as keyof NotesTrimestre];
      let trimSaisis = 0;
      let sommeNotes = 0;
      for (let i = 0; i < 3; i += 1) {
        if (tabNotesTrim[i] !== '') {
          trimSaisis += 1;
          sommeNotes += tabNotesTrim[i] as number;
        }
      }
      if (trimSaisis === 0) {
        setFieldValue(name, '');
      } else {
        setFieldValue(name, Math.round(sommeNotes / trimSaisis * 10) / 10);
      }
    }
  }, [simulation])

  return (
    <div
      className={classNamesZoneSaisie.join(' ')}
      // style={styleZoneSaisie}
    >
      <div className="col1 notesCC">
        <div className="col">
          <h1 className="titre rubrique">{etapesSaisie[indexRubriqueSaisie].nomRubrique}</h1>
          <div className="matiere-coef">
            <h2 className="titre matiere">{label}</h2>
            {spe ? <h2 className="spe">{`spécialité`}</h2> : null}
            <h2 className="coef">{`(coef ${coef})`}</h2>
            {pointsAuDessus10 && <h2 className="pointsAuDessus10">{MessagePointsAuDessus10}</h2>}
          </div>
          {!noteUnique ? <>
          <h3>
            Trimestres
            <Aide
              message={MessageSaisieTrim}
            />
          </h3>
          <div className="group" style={{ display: "flex" }}>
            <div className="groupElement noteT1" style={{ flex: 1 }}>
            <h3>1er</h3>
              <MyTextInput
                name={`${name}_t.0`}
                label=""
                type="number"
                step={0.5}
                min={0}
                max={20}
                format=""
                autoFocus={true}
                // forcedFocus={true}
              />
            </div>
            <div className="groupElement noteT2" style={{ flex: 1 }}>
            <h3>2ème</h3>
              <MyTextInput
                name={`${name}_t.1`}
                label=""
                type="number"
                step={0.5}
                min={0}
                max={20}
                format=""
              />
            </div>
            <div className="groupElement noteT3" style={{ flex: 1 }}>
              <h3>3ème</h3>
              <MyTextInput
                name={`${name}_t.2`}
                label=""
                type="number"
                step={0.5}
                min={0}
                max={20}
                format=""
              />
            </div>
          </div>
          <div className="moyenne_annee">
            <h3>Moyenne année</h3>
            <MyTextInput
              name={name}
              label=""
              // type="number"
              step={0.5}
              min={0}
              max={20}
              format=""
              placeholder="- - -"
              moyenne_annee={true}
              disabled
            />
          </div>
          </>
            : <MyTextInput
              label=""
              // labelAvecRC={<><u>E</u>crit</>}
              // toucheRC={['e', 'E']}
              name={name}
              type="number"
              step={1}
              min={0}
              max={20}
              format=""
              autoFocus={true}
              required
            />

            }
        </div>
      </div>
    </div>
  );
};
